import { ActivatedRoute } from '@angular/router';

import { Injectable } from "@angular/core"

import { Subject } from 'rxjs';
//import { TranslateService } from "@ngx-translate/core";
@Injectable()
export class AppSettingService {
  supportedLangs: any = [
    { display: 'Español', value: 'es' },
    { display: 'English', value: 'en' }
   
  ];

  public static isProdenvironment: boolean = true;

  private _currentLanguage = "currentLanguage";
  public defaultLanguage: string;
  public profilePic = new Subject<string>();
  public profileDetail = new Subject<any>();
  public static userLoggedIn = new Subject<any>();

  public unreadNotifications = new Subject<string>();
  public unreadResponsesCount = new Subject<string>();

  public static RequestFileTypeRegEx = /(\.dll|\.exe|\.sql|\.js)$/i;
  public static RequestFileTypeError = ".dll, .exe, .sql, .bat and .js are not supported."



  
  /****************Session Keys******************/
  private _landingScreenUrl = "hrLandingScreenUrl"
  private _loggedInUser = "prUserInfo";

  private _changePasswordToken = "hrChangePasswordToken";

  public static readonly welcomeVideoURL: string = "https://www.youtube.com/embed/m4s30MgB-jE?controls=1&autoplay=0&rel=0";

  /**********************End of Session*******************88 */

  
  //  static readonly baseUrl: string = "/";
  
  //public static readonly baseUrl: string = "https://qa-providerportal.eniweb.com/";
  public static readonly baseUrl: string = "https://providerportal.eniweb.com/";
  // public static readonly baseUrl: string = "http://localhost:55695/"; 
  // public static readonly baseUrl: string = "https://qa-providerportal.eniweb.com/";

  

  public static forgotPasswordUri = AppSettingService.baseUrl + "api/forgotpassword";
  public static registerUri = AppSettingService.baseUrl + "api/register";
  public static loginUri = AppSettingService.baseUrl + "token";
  public static validateEmailAddressUri = AppSettingService.baseUrl + "api/validateemailaddress";
  public static validateTaxIdUri = AppSettingService.baseUrl + "api/validatetaxid";
  public static contactUsUri = AppSettingService.baseUrl + "api/contacturi";
  public static updatemailingaddressUri = AppSettingService.baseUrl + "api/updatemailingaddress";
  public static getmailingaddressUri = AppSettingService.baseUrl + "api/getmailingaddress";
  public static activateUserUri = AppSettingService.baseUrl + "api/activateuser";
  public static changePasswordUri = AppSettingService.baseUrl + "api/changepassword";
  public static getUserClaimsUri = AppSettingService.baseUrl + "api/getusers";
  public static getPatientsUri = AppSettingService.baseUrl + "api/getpatients";
  public static getPatientHistoryUri = AppSettingService.baseUrl + "api/getpatienthistory";
  public static getClaimDetailUri = AppSettingService.baseUrl + "api/getclaimdetail";
  public static deleteClaimUri = AppSettingService.baseUrl + "api/deleteclaim";
  public static addClaimUri = AppSettingService.baseUrl + "api/addclaim";
  public static getPatientAuthorizationUri = AppSettingService.baseUrl + "api/getpatientauthorization";
  public static loginAsMemberUri = AppSettingService.baseUrl + "api/admin/loginas";
  public static validateAddClaimNoteUri = AppSettingService.baseUrl + "api/validateaddclaimnote";
  public static emailClaimsUri=AppSettingService.baseUrl+"api/emailClaims"
  public static getAvailabilitiesUri=AppSettingService.baseUrl+"api/getavailabilities"
  public static getAvailabilityUri=AppSettingService.baseUrl+"api/getAvailability"
  public static addAvailabilityUri=AppSettingService.baseUrl+"api/addAvailability"
  public static getCounselorsUri=AppSettingService.baseUrl+"api/getCounselors"
  public static getCounselorUri=AppSettingService.baseUrl+"api/getCounselor"
  public static addCounselorUri=AppSettingService.baseUrl+"api/addCounselor"
  public static deleteCounselorUri=AppSettingService.baseUrl+"api/deleteCounselor"
  public static getProviderSitesUri=AppSettingService.baseUrl+"api/getprovidersites"
  public static getProviderSiteUri=AppSettingService.baseUrl+"api/getprovidersite"
  public static addProviderSiteUri=AppSettingService.baseUrl+"api/addprovidersite"
  public static getProviderAddressUri=AppSettingService.baseUrl+"api/getprovideraddress"
  public static addProviderAddressUri = AppSettingService.baseUrl + "api/addprovideraddress"
  public static getLicensesUri=AppSettingService.baseUrl+"api/getLicenses"
  public static getLiabilitiesUri=AppSettingService.baseUrl+"api/getLiabilities"
  public static getLicenseUri=AppSettingService.baseUrl+"api/getlicense"
  public static addLicenseUri=AppSettingService.baseUrl+"api/addlicense"
  public static getLiabilityUri=AppSettingService.baseUrl+"api/getliability"
  public static addLiabilityUri=AppSettingService.baseUrl+"api/addliability"
  public static getLiabiltiyTypesUri=AppSettingService.baseUrl+"api/getliabilitytypes"
  public static getLicenseTypesUri=AppSettingService.baseUrl+"api/getlicensetypes"
  public static getPracticeInformationDetailUri=AppSettingService.baseUrl+"api/getpracticeinformationdetail"
  public static updatepracticeinformationdetailUri=AppSettingService.baseUrl+"api/updatepracticeinformationdetail"
  public static getDocumentData = AppSettingService.baseUrl + "api/getDocumentData";
  public static getDocumentData2 = AppSettingService.baseUrl + "api/getDocumentData2";
  public static getProviderBadgesUri=AppSettingService.baseUrl+"api/getProviderBadges"
  public static emailAttachmentUri = AppSettingService.baseUrl + "api/email/attachment";

  public static getNotificationUri = AppSettingService.baseUrl + "api/getnotifications";
  public static acknowledgeNotificationUri = AppSettingService.baseUrl+"api/acknowledgenotification"
  public static updatenotificationviewstatusUri = AppSettingService.baseUrl+"api/updatenotificationviewstatus"
  public static getBHSSOUrl = AppSettingService.baseUrl+"api/GetBHSSOUrl"
  public static getSubscribeToTextNotifications = AppSettingService.baseUrl+"api/getSubscribeToTextNotifications"
  public static setSubscribeToTextNotifications = AppSettingService.baseUrl+"api/setSubscribeToTextNotifications"
  /****************Web API Global Constants******************/
  // public static maxFileSize = 5000000;
  public static maxFileSize = 5244325; //1048865  //  1048576 1mb
  //public static userCardFileTypeRegEx = /(\.jpg|\.jpeg|\.bmp|\.gif|\.png)$/i;
  public static userRequestFileTypeRegEx = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
  public static userRequestFileTypeError = "Only jpg, jpeg, png and pdf file formats are supported."
  public static userCardFileTypeRegEx = /(\.jpg|\.jpeg|\.png)$/i;
  public static userCardFileTypeError = "Only jpg, jpeg and png image file formats are supported."
  public static userFileSizeError = "Please select the file less than 5mb.";

  public static notificationMaxLength = 70;
  /****************Web API Global Constants ends******************/
  
 public static requiredpinvalidationUri = AppSettingService.baseUrl + "api/requiredpinvalidation";
    get loggedInUser(): any {

    return JSON.parse(localStorage.getItem(this._loggedInUser));
  }

  set loggedInUser(value: any) {
    localStorage.setItem( this._loggedInUser,JSON.stringify( value));
  }

  flushLoggedInUser() {
    localStorage.removeItem(this._loggedInUser);
    let clang=this.currentLanguage;
 
    localStorage.clear();
    localStorage.setItem(this._currentLanguage, clang);
  }

  set changePasswordToken(value: any) {
    localStorage.setItem(this._changePasswordToken, value);
  }
  get changePasswordToken(): any {
    return localStorage.getItem(this._changePasswordToken);
  }

  removechangePasswordToken() {
    localStorage.removeItem(this._changePasswordToken);
  }

  get landingScreenUrl(): any {
    return localStorage.getItem(this._landingScreenUrl);
  }

  set landingScreenUrl(val: any) {
    localStorage.setItem(this._landingScreenUrl, val);
  }

  logout() {

    this.flushLoggedInUser();
  }

  public translatedText: string;
  public supportedLanguages: any[];

  get currentLanguage(): any {

    return localStorage.getItem(this._currentLanguage);
  }

  set currentLanguage(value: any) {

   localStorage.setItem(this._currentLanguage, value);
  }

  get isAuthenticated(): boolean {
    var loggedInUser = this.loggedInUser;
    if (loggedInUser && loggedInUser.access_token) {
      return true;
    }
    return false;
  }

  SetClassOnBody(activatedRoute: ActivatedRoute) {


    var routerClassName = ""
    activatedRoute
      .data
      .subscribe(className => {
        routerClassName = className["activeClass"];

        document.getElementById('body').className = routerClassName;
      });
  }

}
